import { type CreateChannelState } from '@sendbird/uikit-react/CreateChannel/context';

export type CHANNEL_TYPE = CreateChannelState['type'];

export const CHANNEL_TYPE = {
  GROUP: 'group' as CHANNEL_TYPE,
  SUPERGROUP: 'supergroup' as CHANNEL_TYPE,
  BROADCAST: 'broadcast' as CHANNEL_TYPE,
};

export type SearchMode = {
  mode: 'channel' | 'employee';
  label: string;
};
